import { GridProps } from "@progress/kendo-react-grid/dist/npm/interfaces/GridProps";
import { useCallback } from "react";
import {
  getSelectedState,
  GridHeaderSelectionChangeEvent,
  GridSelectionChangeEvent,
} from "@progress/kendo-react-grid";
import _ from "lodash";
import { SELECTED_FIELD } from "./GridConstants";

interface Props<T> {
  readonly selectedState: {
    [id: number]: boolean | number[];
  };
  readonly setSelectedState: (selectedState: { [id: number]: boolean | number[] }) => void;
  readonly setSelectedIds: (n: Array<number>) => void;
  readonly dataItemKey: keyof T & string;
  readonly setAllItemsSelected?: (allSelected: boolean) => void;
}

export const GridSelectableRowsProps = <T, P extends Props<T> = Props<T>>({
  selectedState,
  setSelectedState,
  setSelectedIds,
  dataItemKey,
  setAllItemsSelected,
}: P): GridProps => {
  const onSelectionChange = useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState,
        dataItemKey,
      });

      setSelectedState(newSelectedState);
      setSelectedIds(getSelectedIdsByEvent(newSelectedState));
    },
    [selectedState]
  );

  function getSelectedIdsByEvent(newSelectedState: { [id: number]: boolean | number[] }) {
    return Object.keys(newSelectedState)
      .map((id: any) => {
        return newSelectedState[id] === true ? id : null;
      })
      .filter((val) => val != null)
      .map((x) => Number(x));
  }

  const onHeaderSelectionChange = useCallback((event: GridHeaderSelectionChangeEvent) => {
    const checkboxElement: any = event.syntheticEvent.target;
    const { checked } = checkboxElement;
    const newSelectedState: {
      [id: number]: boolean | number[];
    } = {};

    event.dataItems.forEach((item) => {
      newSelectedState[_.get(item, dataItemKey)] = checked;
    });
    if (setAllItemsSelected) {
      setAllItemsSelected(checked);
    }
    setSelectedIds(getSelectedIdsByEvent(newSelectedState));
    setSelectedState(newSelectedState);
  }, []);

  return {
    dataItemKey,
    selectedField: SELECTED_FIELD,
    selectable: {
      enabled: true,
      drag: false,
      cell: false,
      mode: "multiple",
    },
    onSelectionChange,
    onHeaderSelectionChange,
  };
};
